import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ValidatorService } from '../../shared/editable-mat-table/validator.service';

@Injectable()
export class BusinessHoursValidatorService implements ValidatorService {
  getRowValidator(): FormGroup {
    return new FormGroup({
      'From Date': new FormControl('', [Validators.required, Validators.pattern('^(0[1-9]|1[0-2])\\/([012][0-9]|3[01])$')]),
      'To Date': new FormControl('', [Validators.required, Validators.pattern('^(0[1-9]|1[0-2])\\/([012][0-9]|3[01])$')]),
      'From Day': new FormControl('', Validators.required),
      'To Day': new FormControl('', Validators.required),
      'From Time': new FormControl('', Validators.required),
      'To Time': new FormControl('', Validators.required)
    });
  }
}
